import MediaModel from './mediaModel';
import {cloneObject} from '../../sinclair/sinclair.utils';
import RenditionSetModel from './renditionSetModel';

const ImageModel = MediaModel.extend({
    urlRoot: '/platform/media',
    idAttribute: 'uuid',
    defaults: {},
    initialize(data) {
        return this.parse(data);
    },
    parse(data) {
        const that = this;
        const model = cloneObject(data.media ? data.media : data);
        const {width, height} = model;
        if (model.renditions) {
            if (that.get('renditions') instanceof RenditionSetModel) {
                that.get('renditions').parse(model.renditions);
            } else {
                that.set({renditions: new RenditionSetModel(model.renditions)});
            }

            model.renditions = that.get('renditions');
            model.renditions.setParentDimensions({width, height});
            model.renditions.fixNulls();
        }

        return model;
    },
    getCropInfoForRendition(renditionName) {
        const rendition = this.getRendition(renditionName);
        let cropInfo;

        if (rendition) {
            const _rendition = rendition.toJSON();
            cropInfo = Object.create(_rendition);
            // crop scale is used for the UI to determine
            cropInfo.x = _rendition.x;
            cropInfo.y = _rendition.y;
            cropInfo.width = _rendition.width;
            cropInfo.height = _rendition.height;
            cropInfo.x2 = cropInfo.x + cropInfo.width;
            cropInfo.y2 = cropInfo.y + cropInfo.height;
            cropInfo.aspectRatio = cropInfo.width / cropInfo.height;
        } else {
            console.error('No rendition found with the key: %s', renditionName);
        }
        return cropInfo;
    },
    hasLowResolutionRendition() {
        return this.getResolutionWarnings().length;
    },
    getRendition(rendition) {
        return this.get('renditions').get(rendition);
    },
    getResolutionWarnings() {
        const renditions = this.get('renditions').toJSON();

        return Object.keys(renditions).filter(function(renditionName) {
            const rendition = renditions[renditionName];
            return rendition.width < rendition.scaleWidth;
        });
    },
    _renditionsToLegacyArray(renditionJSON) {
        return Object.keys(renditionJSON).map(function(key) {
            return {
                uuid: '',
                name: key + 'Url',
                value: renditionJSON[key].url,
                parent: null,
            };
        });
    },
    getSmallestUrlOfSize(size) {
        const scales = ['small', 'medium', 'large'];

        const smallest = scales
            .filter(scale => this.getRendition(scale + size))
            .reduce((prev, next) => prev || this.getRendition(next + size).toJSON().url, null);

        if (smallest) {
            return smallest;
        } else {
            console.error('There was no url of any size for the %s aspect ratio', size);
            return '';
        }
    },
    getLegacyJSON() {
        const that = this;
        const json = that.toJSON();
        const legacyJSON = {
            image: {
                type: 'Image',
                uuid: json.uuid,
                title: json.title,
                version: json.version,
                attributes: that._renditionsToLegacyArray(json.renditions),
                caption: json.caption,
                original: json.original,
            },
        };

        Object.keys(json.renditions).forEach(function(key) {
            legacyJSON.image[key + 'Url'] = json.renditions[key].url;
        });

        return legacyJSON;
    },
    getExtraRequestParams(method) {
        const params = MediaModel.prototype.getExtraRequestParams.call(this, method);
        if (method === 'update') {
            params.updateRenditions = this.get('renditions').hasSomeRenditionChanged();
        }
        return params;
    },
});

export default ImageModel;
